import { motion } from "framer-motion";
import { Check, ArrowUpRight } from "lucide-react";
import SectionHeading from "./SectionHeading";
import LangLink from "../shared/LangLink";
import { Reveal, StaggerGroup, StaggerItem } from "../shared/Reveal";
import { WHY_VIETNAM } from "../../data/homeContent";

export default function WhyVietnam() {
  return (
    <section className="bg-background py-20 md:py-28 lg:py-36" data-testid="why-vietnam">
      <div className="container-psv grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5">
          <Reveal className="relative overflow-hidden rounded-[2rem] grain h-[420px] lg:h-[560px] border border-border">
            <motion.img
              src="https://images.unsplash.com/photo-1528360983277-13d401cdc186?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
              alt="A calm Vietnamese landscape suitable for a planned recovery period"
              className="w-full h-full object-cover"
              loading="lazy"
              whileHover={{ scale: 1.04 }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            />
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <SectionHeading eyebrow={WHY_VIETNAM.eyebrow} heading={WHY_VIETNAM.heading} intro={WHY_VIETNAM.intro} />
          <StaggerGroup className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
            {WHY_VIETNAM.points.map((p) => (
              <StaggerItem key={p} className="flex items-start gap-3">
                <Check className="w-5 h-5 text-accent shrink-0 mt-0.5" strokeWidth={1.75} />
                <span className="text-[15px] text-secondary-foreground">{p}</span>
              </StaggerItem>
            ))}
          </StaggerGroup>
          <LangLink to={WHY_VIETNAM.linkTo} className="mt-10 inline-flex items-center gap-2 text-accent font-medium font-sans hover:gap-3 transition-all" data-testid="why-vietnam-link">
            {WHY_VIETNAM.link} <ArrowUpRight className="w-4 h-4" />
          </LangLink>
        </div>
      </div>
    </section>
  );
}
